

import { useOrdenesCompraQuery } from "../../../hooks";
import { CargandoMedio } from "../../components";
import { TablaOrdenCompras } from "../../components/facturas";
import { DisenioPaginas } from "../../layout";




export const ListOrdenesCompra = () => {


  const { data, isLoading, chagePage, page } = useOrdenesCompraQuery();



  return (

      <DisenioPaginas titulo="Listado Ordenes de Compra" url={1} add={false}>
        {( isLoading )
        ?   <CargandoMedio titulo="Cargando Información de ordenes de compra" />

        :   <>
            {/* <BotonesGroup botonesOpciones={botonesOpciones} /> */}
              <TablaOrdenCompras data={data || []} chagePage={ chagePage } page={ page } />
            </>

        }
        
        {/* <ModalFormUno titulo={`Crear Solicitud`} valor={{}} onClose={() => changeEstadoModalUno(false)}>
            <FormularioSolicitudes />
        </ModalFormUno> */}
      </DisenioPaginas>
  )
}
